import { type NormalRow } from '../type';

export const createGroupKey = (row: NormalRow, columnIds: string[]): string => {
  return columnIds
    .map((colId) => {
      const value = row[colId];
      return value == null ? 'null' : String(value);
    })
    .join('|');
};

export const groupRowsByKey = (rows: NormalRow[], columnId: string): Map<string, NormalRow[]> => {
  const groupMap = new Map<string, NormalRow[]>();

  for (const row of rows) {
    const value = row[columnId];
    const key = value == null ? 'null' : String(value);

    const group = groupMap.get(key);
    if (group) {
      group.push(row);
    } else {
      groupMap.set(key, [row]);
    }
  }

  return groupMap;
};
